import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CustomPurposeIds } from '@wetransfer/transfer/modules/consent-manager/config';
import tcModel from '@wetransfer/transfer/modules/consent-manager/tc-model';
import I18n from '@wetransfer/transfer/modules/i18n';

import { Consent } from './consent';

function initCustomPurposesState() {
  const state = {};
  const id = CustomPurposeIds.PROMOTE_PRODUCTS;
  state[id] = {
    id,
    name: I18n.t('transfer.consent-manager.purpose-title'),
    descriptionLegal: [
      I18n.t('transfer.consent-manager.purpose-description-first-intro'),
      I18n.t('transfer.consent-manager.purpose-description-first-list'),
      I18n.t('transfer.consent-manager.purpose-description-second-intro'),
      I18n.t('transfer.consent-manager.purpose-description-second-list'),
    ].join(''),
    purposeConsent: tcModel.purposeConsents.has(id),
    purposeLegitimateInterest: tcModel.purposeLegitimateInterests.has(id),
    descriptionVisible: false,
    purposeConsentVisible: true,
  };

  return state;
}

export function CustomPurposes({ language, isWhiteText }) {
  const [preferences, setPreferences] = useState(initCustomPurposesState());

  useEffect(() => {
    setPreferences(initCustomPurposesState());
  }, [language]);

  const handlePurposeConsent = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeConsent = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeConsents.set(id);

      return;
    }

    tcModel.purposeConsents.unset(id);
  };

  const handleLegitimateInterest = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].purposeLegitimateInterest = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.purposeLegitimateInterests.set(id);

      return;
    }

    tcModel.purposeLegitimateInterests.unset(id);
  };

  const toggleDescription = (id) => {
    const newPref = { ...preferences };
    newPref[id].descriptionVisible = !newPref[id].descriptionVisible;
    setPreferences(newPref);
  };

  return Object.values(preferences).map((consent, index) => (
    <Consent
      key={index}
      onToggle={() => toggleDescription(consent.id)}
      consentName={consent.name}
      className={`consent ${isWhiteText ? 'consent__white' : ''}`}
      descriptionVisible={consent.descriptionVisible}
      consentSwitchesProps={[
        {
          name: `legitimate-${consent.id}`,
          label: I18n.t('transfer.consent-manager.switch-by-we-transfer'),
          onChange: (checked) => handleLegitimateInterest(consent.id, checked),
          checked: consent.purposeLegitimateInterest,
        },
        {
          name: `purpose-${consent.id}`,
          disabled: !consent.purposeConsentVisible,
          label: I18n.t('transfer.consent-manager.switch-by-partners'),
          onChange: (checked) => handlePurposeConsent(consent.id, checked),
          checked: consent.purposeConsent,
        },
      ]}
    >
      <div
        className="consent__text"
        dangerouslySetInnerHTML={{
          __html: consent.descriptionLegal,
        }}
      />
    </Consent>
  ));
}

CustomPurposes.propTypes = {
  language: PropTypes.string,
  isWhiteText: PropTypes.bool,
};

const mapStateToProps = ({ session: { language } }) => ({ language });

export const ConnectedCustomPurposes = connect(mapStateToProps)(CustomPurposes);
